import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom";
import merasIcon from "assets/images/meras-name.png";
import {
	Carousel,
	CarouselItem,
	CarouselControl,
	CarouselIndicators,
	CarouselCaption,
} from "reactstrap";
import { authenticate } from "store/Auth/actions";
import { useTranslation } from "react-i18next";

const Explore = ({ history }) => {
	const [projects, setProjects] = useState([]);
	const [activeIndex, setActiveIndex] = useState(0);
	const [animating, setAnimating] = useState(false);
	const lang = useSelector((state) => state?.Auth?.lang);
	const filterData = useSelector((state) => state.filter);
	const AuthData = useSelector((state) => state.Auth);
	const dispatch = useDispatch();
	const { t } = useTranslation();

	useEffect(() => {
		if (!!filterData?.homeNewProjects?.length)
			setProjects(filterData?.homeNewProjects);
	}, [filterData]);

	const checkAuth = (id) => {
		if (AuthData.token && AuthData.userType === "user") {
			history.push(`/compound-details/${id}`);
		} else {
			dispatch(authenticate({ navigateTo: `/compound-details/${id}` }));
			history.push(`/login`, { navigateTo: `/compound-details/${id}` });
		}
	};
	// checkAuth(item?.id)

	return (
		<div className="container pt-5 pb-lg-4">
			<div className="exploreTopSection pb-md-5">
				<div className="home-title d-lg-flex justify-content-between align-items-center">
					<h2 className="title">
						<span className="gotham-font">{t("Explore")}</span>
						<span className="bask-font mx-3">{t("new projects")}</span>
					</h2>
					<div className="d-lg-flex align-items-center" style={{ gap: "24px" }}>
						<p className="allYouNeed">
							<span className="d-block">{t("All You Need To Know About")}</span>
							<span className="d-block">
								{t("Trending and upcoming projects")}
							</span>
						</p>
						<p className="allYouNeed-mobile">
							<span className="d-block">
								{t("All You Need To Know About Trending and upcoming projects")}
							</span>
						</p>
						<button
							className="btn view-All-link"
							type={"button"}
							onClick={() => {
								history.push("/resales", "compounds_hidden");
							}}>
							{t("View All")}
						</button>
					</div>
				</div>
				<img src={merasIcon} className="merasIcon" alt="merasIcon" />
			</div>
		</div>
	);
};

export default Explore;
